import { useEffect } from 'react';

import { Form, Skeleton } from 'antd';
import { isSharedIdentificationFeatureEnabled } from 'constant';
import { useGetRelationGroupByIdQuery } from 'services';

import ArticleGroupFields from './article-group-fields';
import { getMainMemberPayload } from './main-member';
import { getShareIdentificationPayload, isSharedIdentification } from './share-identification';

const FORM_ID = 'article-group-form';

/**
 * Madde grubu düzenleme formu. Grup detayını çeker ve kendi useForm instance'ını yönetir.
 * @param {Object} props
 * @param {number} props.groupId - Düzenlenecek grubun ID'si
 * @param {Function} props.onSubmit - Submit callback ({ name, members: [{ articleOffer, position, memberId? }], mainMemberArticleOffer?, shareIdentification? })
 */
function ArticleEditForm({ groupId, onSubmit }) {
  const [form] = Form.useForm();
  const { data: groupDetail, isLoading } = useGetRelationGroupByIdQuery({ groupId });
  const initialShareIdentification = groupDetail?.shareIdentification === true;
  const sharedIdentificationCard = isSharedIdentification(groupDetail)
    ? (groupDetail.sharedIdentificationCard ?? null)
    : null;

  useEffect(() => {
    if (!groupDetail) return;

    const members = groupDetail.members ?? [];
    // Eski gruplarda `mainMember` null gelebilir; o zaman 1. sıradaki üye ana maddedir.
    const mainIndex = Math.max(
      members.findIndex((member) => member['@id'] === groupDetail.mainMember?.['@id']),
      0,
    );

    form.setFieldsValue({
      name: groupDetail.name,
      members: members.map((member, index) => ({
        id: member.articleOffer.id,
        '@id': member.articleOffer['@id'],
        label: member.articleOffer.title,
        status: member.articleOffer.status,
        step: member.articleOffer.step,
        memberId: member['@id'],
        isMain: index === mainIndex,
        identificationCard: member.identificationCard,
      })),
      shareIdentification: initialShareIdentification,
    });
  }, [groupDetail, initialShareIdentification, form]);

  const handleFinish = (values) => {
    const formMembers = values.members ?? [];
    const members = formMembers.map((member, index) => ({
      articleOffer: member['@id'],
      position: index + 1,
      ...(member.memberId && { id: member.memberId }),
    }));

    onSubmit({
      name: values.name,
      members,
      ...getMainMemberPayload(formMembers),
      ...getShareIdentificationPayload(Boolean(values.shareIdentification), initialShareIdentification),
    });
  };

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 4 }} />;
  }

  return (
    <ArticleGroupFields
      form={form}
      formId={FORM_ID}
      onFinish={handleFinish}
      showSharePanel={isSharedIdentificationFeatureEnabled}
      initialShareIdentification={initialShareIdentification}
      sharedIdentificationCard={sharedIdentificationCard}
    />
  );
}

export default ArticleEditForm;
